function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Platform, Text as RNText } from 'react-native';
import { withTheme } from '../../core/theming';
export let TextType;

(function (TextType) {
  TextType["Headline1"] = "headline1";
  TextType["Headline2"] = "headline2";
  TextType["Subtitle"] = "subtitle";
  TextType["SubtitleBold"] = "subtitleBold";
  TextType["Body"] = "body";
  TextType["BodyBold"] = "bodyBold";
  TextType["BodyWide"] = "bodyWide";
  TextType["ButtonPrimary"] = "buttonPrimary";
  TextType["ButtonSecondary"] = "buttonSecondary";
  TextType["Overline"] = "overline";
  TextType["OverlineBold"] = "overlineBold";
  TextType["Caption1"] = "caption1";
  TextType["Caption1Bold"] = "caption1Bold";
  TextType["Caption2"] = "caption2";
  TextType["Caption2Bold"] = "caption2Bold";
  TextType["Caption3"] = "caption3";
  TextType["Caption3Bold"] = "caption3Bold";
})(TextType || (TextType = {}));

const Text = _ref => {
  let {
    style,
    type = TextType.Body,
    theme: {
      colors,
      fonts,
      isRTL
    },
    color = colors.text.default,
    children,
    ...props
  } = _ref;
  const typeCustomStyle = getFontByType();
  const styles = [typeCustomStyle, {
    color: color
  }, style];
  const offsetTop = typeCustomStyle.lineHeight && typeCustomStyle.fontSize && typeCustomStyle.lineHeight < typeCustomStyle.fontSize ? typeCustomStyle.fontSize - typeCustomStyle.lineHeight : null;
  return /*#__PURE__*/React.createElement(RNText, _extends({}, props, {
    style: [offsetTop !== null && Platform.select({
      ios: {
        paddingTop: offsetTop
      },
      android: {
        paddingTop: offsetTop
      }
    }), {
      writingDirection: isRTL ? 'rtl' : 'ltr'
    }, styles]
  }), children);

  function getFontByType() {
    return fonts[type] || fonts.body;
  }
};

export default withTheme(Text);
//# sourceMappingURL=Text.js.map